import React from 'react';
import { connect } from 'react-redux';
import { addTicket, subTicket } from '../store/tickets';
import { showModal } from '../store/ui';

import { formatPrice } from '../helpers';


const TicketType = ({ id, name, price, numTickets, prev, next, addTicket, subTicket, code, area, maxQuantity, color, message, folio, showModal, showedMessages, shouldShowCategoryMessage, min_quantity}) => {

  const handleAddTicket = () => {
    addTicket({ type: id, price: +price, code, area, folio, min_quantity }); 
    if(numTickets === 0 && message !== '' && !showedMessages.has(message)) showModal({ position: `tickets-message`, message, shouldShowCategoryMessage });
  };

  const handleSubTicket = () => {
    subTicket({ type: id, price: +price, code, area, folio });
  };

  return (
    <li className="ticket__row">
      <div className="ticket__col">
        <p className="text" style={{ color }}>{name} 
        {folio !== null ? `****${folio.substring(folio.length - 4, folio.length)}` : null}</p>
      </div>
      <div className="ticket__col ticket__col--aright">
        <p className="price">{formatPrice(price)} €</p>
      </div>
      <div className="ticket__col ticket__qty">
        <div className="ticket__actions">
          <div className="ticket__container">
            <button type="button" className="ticket__action" onClick={handleSubTicket} disabled={numTickets <= 0 || !prev} aria-label={`Quitar un boleto ${name}`}>
              <svg width="7" height="7" viewBox="0 0 11 1"><path fill="#08285b" fillRule="nonzero" d="M0 1V0h11v1z" /></svg>
            </button>
            <div className="ticket__input">{numTickets}</div>
            <button type="button" className="ticket__action" onClick={handleAddTicket} disabled={numTickets >= maxQuantity || !next} aria-label={`Añadir un boleto ${name}`}>
              <svg width="7" height="7" viewBox="0 0 11 11"><g fill="#08285b" fillRule="nonzero"><path d="M0 6V5h11v1z" /><path d="M6 11H5V0h1z" /></g></svg>
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

const mapStateToProps = ({ tickets, ui }, ownProps) => {
  return {
    numTickets: tickets.types[ownProps.id] || 0,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (obj) => dispatch(showModal(obj)),
    addTicket: (obj) => dispatch(addTicket(obj)),
    subTicket: (obj) => dispatch(subTicket(obj))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketType);
